import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer, Tooltip } from 'recharts';
import { useTheme } from '../contexts/ThemeContext';

const ComponentHealth = ({ components }) => {
  const { theme, getThemeClasses } = useTheme();
  const themeClasses = getThemeClasses();
  
  // Helper to extract numeric health value (handle both old format (number) and new format (object))
  const getHealthValue = (componentName) => {
    const value = components[componentName];
    if (typeof value === 'object' && value !== null) {
      return value.health || 0;
    }
    return typeof value === 'number' ? value : 0;
  };
  
  // Transform the components data for radar chart
  const chartData = [
    { component: 'Engine', health: getHealthValue('engine') },
    { component: 'Suspension', health: getHealthValue('suspension') },
    { component: 'Brakes', health: getHealthValue('brakes') },
    { component: 'Transmission', health: getHealthValue('transmission') },
  ];

  // Custom tooltip with theme support
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const tooltipBg = theme === 'light' ? 'bg-white border border-gray-300 shadow-lg' : 'bg-black/90 border border-military-700/50';
      const textPrimary = theme === 'light' ? 'text-gray-900' : 'text-white';
      const textAccent = theme === 'light' ? 'text-military-600' : 'text-blue-400';
      
      return (
        <div className={`${tooltipBg} rounded-lg p-3 shadow-xl`}>
          <p className={`${textPrimary} font-semibold`}>{payload[0].payload.component}</p>
          <p className={`${textAccent} font-bold`}>{payload[0].value}%</p>
        </div>
      );
    }
    return null;
  };

  // Theme-aware colors
  const gridColor = theme === 'light' ? '#d1d5db' : '#4B5563';
  const textColor = theme === 'light' ? '#374151' : '#D1D5DB';
  const secondaryTextColor = theme === 'light' ? '#6b7280' : '#9CA3AF';
  const radarColor = theme === 'light' ? '#2563eb' : '#3B82F6';

  return (
    <div className={`${themeClasses.chartBackground} border ${themeClasses.border} rounded-xl p-3 sm:p-4 lg:p-6`}>
      <h3 className={`text-base sm:text-lg lg:text-xl font-bold ${themeClasses.textPrimary} mb-3 sm:mb-4`}>Component Health Analysis</h3>
      <div className="w-full h-64 sm:h-72 lg:h-80">
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={chartData}>
            <PolarGrid stroke={gridColor} strokeWidth={1} />
            <PolarAngleAxis
              dataKey="component"
              tick={{ fill: textColor, fontSize: 14, fontWeight: 500 }}
            />
            <PolarRadiusAxis
              angle={90}
              domain={[0, 100]}
              tick={{ fill: secondaryTextColor, fontSize: 12 }}
            />
            <Radar
              name="Health"
              dataKey="health"
              stroke={radarColor}
              fill={radarColor}
              fillOpacity={theme === 'light' ? 0.3 : 0.6}
              strokeWidth={2}
            />
            <Tooltip content={<CustomTooltip />} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ComponentHealth;
